import { render, staticRenderFns } from "./ExercisesScreen.vue?vue&type=template&id=06a4a5d0&scoped=true"
import script from "./ExercisesScreen.vue?vue&type=script&lang=js"
export * from "./ExercisesScreen.vue?vue&type=script&lang=js"
import style0 from "./ExercisesScreen.vue?vue&type=style&index=0&id=06a4a5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4a5d0",
  null
  
)

export default component.exports